// Redux-Persist compatible storage using IndexedDB. No fallback to localStorage.
import idb from './indexedDB';

const storage = {
  getItem: (key) => idb.getItem(key),
  setItem: (key, value) => idb.setItem(key, value),
  removeItem: (key) => idb.removeItem(key),
};

export default storage;
